import {Inject, Injectable} from '@angular/core';
import { SecureApi } from '../../core/secure.api';

@Injectable()
export class MeRegisterService {
    step = 1;
    patientEmail = '';
    patientPassword = '';
    jwt = '';

    constructor(
       private secureApi : SecureApi
    ) {

    }

    register(data, clinicId) {
        return this.secureApi.post('patients/registration/' + clinicId, data, false);
    }

    checkVoucher(voucher) {
        return this.secureApi.get('patients/get-clinic-voucher/' + voucher);
    }

    checkJwtToken(voucher) {
        return this.secureApi.get('b2c-patients/check-jwt-token/' + voucher);
    }

    verify(data) {
        return this.secureApi.post('users/verify-patient-registration', data, false);
    }

    resendVerify(data) {
        return this.secureApi.post('b2c-patients/resend-verify-mail', data, false);
    }
}
